export function trackEvent(eventName: string, eventParams: Record<string, any> = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
}

// Booking Analytics Tracking
export function trackBookingStarted(params: {
  booking_type: string;
  destination?: string;
  price?: number;
  currency?: string;
}) {
  trackEvent('begin_checkout', {
    currency: params.currency || 'GBP',
    value: params.price || 0,
    items: [{
      item_category: params.booking_type,
      item_name: params.destination || params.booking_type,
      price: params.price || 0,
    }],
  });
  trackEvent('booking_started', params);
}

export function trackBookingCompleted(params: {
  booking_ref: string;
  booking_type: string;
  total_price: number;
  destination?: string;
  passengers?: number;
  currency?: string;
}) {
  trackEvent('purchase', {
    transaction_id: params.booking_ref,
    currency: params.currency || 'GBP',
    value: params.total_price,
    items: [{
      item_category: params.booking_type,
      item_name: params.destination || params.booking_type,
      price: params.total_price,
      quantity: params.passengers || 1,
    }],
  });
  trackEvent('booking_completed', params);
}

export function trackBookingAbandoned(params: {
  booking_type: string;
  step: string;
  price?: number;
}) {
  trackEvent('booking_abandoned', params);
}

export function trackSearchPerformed(params: {
  search_type: string;
  origin?: string;
  destination?: string;
  passengers?: number;
  cabin_class?: string;
}) {
  trackEvent('search', {
    search_term: `${params.origin || ''} to ${params.destination || ''}`,
    ...params,
  });
}

export function trackAIRecommendationViewed(params: {
  interest: string;
  budget: string;
  destinations_shown: number;
}) {
  trackEvent('ai_recommendation_viewed', params);
}

export function trackLeadSubmitted(params: {
  source: string;
  destination?: string;
  budget?: string;
}) {
  trackEvent('generate_lead', {
    currency: 'GBP',
    ...params,
  });
}

export function trackLeadFormConversion(params: {
  form_location: string;
  destination?: string;
  travel_type?: string;
  passengers?: number;
  budget?: string;
  method: 'form' | 'whatsapp';
}) {
  trackEvent('conversion', {
    send_to: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
    event_category: 'lead_form',
    event_label: params.form_location,
    ...params,
  });
  trackEvent('lead_form_submitted', params);
}

export function trackThankYouPageView(params: {
  ref_number: string;
  source?: string;
}) {
  // Push to GTM dataLayer for Tag Manager conversion triggers
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quote_thankyou_view',
      event_category: 'conversion',
      event_label: 'enquiry_submitted',
      ref_number: params.ref_number,
      source: params.source || 'quote_form',
    });
  }
  // Also fire GA4 event
  trackEvent('thank_you_page_view', {
    event_category: 'conversion',
    event_label: 'enquiry_submitted',
    ...params,
  });
}

export function trackFollowUpAction(params: {
  action: 'whatsapp_click' | 'call_click' | 'destination_click' | 'social_share';
  label?: string;
  ref_number?: string;
}) {
  trackEvent('follow_up_action', {
    event_category: 'thank_you_page',
    ...params,
  });
}

// Declare global types for TypeScript
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}